<template>

  <div class="home-wrap"></div>

</template>

<script>
import { mapState } from 'vuex'
import util from '@/utils/util'
import table from '@/api/table'
import actions from "@/shared/actions";
export default {
  name: 'home',
  data () {
    return {}
  },
  computed:{
    ...mapState(['technician','userStatus'])
  },
  methods:{
    // 判断之前是否选择过门店
    judge(storeList){
      let i=true
      // 判断之前是否选择过门店
      storeList.forEach(item=>{
        // this.userStatus.curs_node_id_1.substring(0,5)==item.node_id.substring(0,5)
        if(this.userStatus.curs_node_id_1==item.node_id){
            let renderBarList=util.navAuthority(this.technician.navTabBar,this.userStatus.technician_power)
            if(renderBarList.length>0){
              i=false
              this.navAuthority()
            }
        }
      })
      if(i){this.$router.push({path: 'store-message', query: {to:'achievement'}})}
    },
    // tabBar菜单权限筛选
    navAuthority(){
      if(!this.authDeadline()){ return location.href=location.protocol+'//'+location.host+'/payIndex'+'?key=technician'}
      let renderBarList=util.navAuthority(this.technician.navTabBar,this.userStatus.technician_power)
      if(renderBarList.length>0){
        this.$store.commit('updateRenderBarList',renderBarList)
        this.$router.push({
        	name:renderBarList[0].link
        })
      }
    },
    // 可用门店列表
    getShopList(){
      table.getShopList().then(response=>{
        this.judge(response.data.list)
        // 判断所在门店的名称
        response.data.list.forEach(item=>{
          if(this.userStatus.curs_node_id_1==item.node_id){
            localStorage.setItem('shopNameTitle',item.shop_name)
          }
        })
      })
    },
    // 期限
    authDeadline(){
      return util.getRestDay(this.userStatus.vip_1)
    }
  },
  mounted(){
    actions.onGlobalStateChange((state) => {
      this.$store.commit("updateUserStatus",state.userStatus)
    }, true)
    if(localStorage.getItem('sub')==1){
      localStorage.setItem('sub',0)
      this.getShopList()
    }else{
      this.$router.go(-1);//返回上一层
    }
  },
  created(){
  }
}
</script>
<style lang="scss" scoped>
  .home-wrap {

  }
</style>
